module.exports = __webpack_public_path__ + "static/media/logo_footer.829096c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_footer.svg
// module id = 806
// module chunks = 2